const USERS = {
  ROW: "Row",
  USERS_LIST_TITLE: "Online Users",
  A11Y: "Accessibilities",
  USER: "User",
  PAGE: "Page",
  CHAT: "Chat",
  CHATTING_WITH: "Chatting with",
  START_CHAT: "Start Chat",
  START: "Start",
  CONVS_LIST: "Conversations",
  FORM_INFO: "Form",
  ROADMAP: "Roadmap",
  SEARCH_IN_USERS: "Search In Users",
};

export default USERS;
